import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthenticateService } from './authenticate.service';
import { envs } from '../data/env.data';
import { Observable } from 'rxjs';
import { ClipRequest, ClipResponse } from '../model/clip-response';

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthenticateService);

  clipCoupon(clip: ClipRequest[], banner: string): Observable<ClipResponse[]> {
    const url = `${envs.apiBaseUrl}/${banner}/coupons/clip`;
    const token = this.authService.getApiAuthToken();
    const header = {
      Authorization: token,
    };
    const body: ClipRequest[] = clip;

    return this.http.post<ClipResponse[]>(url, body, { headers: header });
  }
}
